import { InMemoryObjectBase } from '../../../helpers/in-memory-object';
import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { Guid } from '../../../helpers/Guid';
import { Company } from './company';
import { CompanyWorkingHours } from './company-working-hours';

export class InMemoryCompanyInfo extends InMemoryObjectBase<Company> {

  protected get storeKeyName(): string {
    return 'in_memory_company';
  }

  protected _createDemoItems(): Company[] {
    return [
      new Company(
        'Name Company',
        'City',
        'Street',
        47057,
        'Country',
        'Site',
        'Phone number',
        'E-mail',
        'UID-Number',
        'Subsidiary Company',
        'UID-Number',
        'Map Position',
        )
    ];
  }

 get CompanyOpenHours(): CompanyWorkingHours[] {
   return [
     new CompanyWorkingHours(1, 0, 0),
     new CompanyWorkingHours(2, 14.5, 21.0),
     new CompanyWorkingHours(3, 10.0, 21.0),
     new CompanyWorkingHours(4, 10.0, 21.0),
     new CompanyWorkingHours(5, 10.0, 23.0),
     new CompanyWorkingHours(6, 9.0, 23.0),
     new CompanyWorkingHours(0, 9.0, 21.0),
    ];
 }

 get CompanyTodayWorkingHours(): CompanyWorkingHours {
   return new CompanyWorkingHours(1, 10.0, 21.0);
 }

  protected _FromJSON(json: string): Company[] {
    return JSONUtilites.arrayFromJSON<Company>(null, json, Company.createFromAny);
  }
}

